import { useEffect, useRef, useState } from "react";
import { useEditorCommands } from "@linempo/react-state";
import type { AssetDescriptor } from "@linempo/project-domain";
import { errorMessage } from "../../editor-geometry.js";

/** Component-owned URL lease. A late read is released even after selection change/unmount. */
export function useAssetUrl(asset: AssetDescriptor | undefined, onError: (message: string) => void): string {
  const commands = useEditorCommands();
  const report = useRef(onError); report.current = onError;
  const liveUrl = useRef("");
  const key = asset ? `${asset.id}:${asset.hash}` : "";
  const [source, setSource] = useState({ key: "", url: "" });
  useEffect(() => {
    if (!asset) return;
    let active = true; let release: (() => void) | undefined;
    void commands.readAsset(asset).then((handle) => {
      if (!active) { handle.release(); return; }
      release = handle.release; liveUrl.current = handle.url; setSource({ key, url: handle.url });
    }, (error: unknown) => { if (active) report.current(errorMessage(error)); });
    return () => { active = false; liveUrl.current = ""; release?.(); };
  }, [commands, key]);
  return source.key === key && source.url === liveUrl.current ? source.url : "";
}
